import { render, staticRenderFns } from "./QuickAddButtons.vue?vue&type=template&id=1200ea1c&scoped=true"
import script from "./QuickAddButtons.vue?vue&type=script&lang=ts"
export * from "./QuickAddButtons.vue?vue&type=script&lang=ts"
import style0 from "./QuickAddButtons.vue?vue&type=style&index=0&id=1200ea1c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1200ea1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1200ea1c')) {
      api.createRecord('1200ea1c', component.options)
    } else {
      api.reload('1200ea1c', component.options)
    }
    module.hot.accept("./QuickAddButtons.vue?vue&type=template&id=1200ea1c&scoped=true", function () {
      api.rerender('1200ea1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/QuickAddButtons.vue"
export default component.exports